import { FC } from 'react';
import { AdminDiscountReportsList } from 'containers/admin';
import { AdminDiscountsLayout } from 'pages/atoms';

const AdminDiscountsPage: FC = () => {
  return (
    <AdminDiscountsLayout>
      <AdminDiscountReportsList />
    </AdminDiscountsLayout>
  );
};

export default AdminDiscountsPage;
